export default __webpack_public_path__ + "static/video_loop_2-cee60cf9a3c2490b39fe23b3f60aa13a.mp4";